import { Card, Row } from 'antd';
import dayjs from 'dayjs';
import { Folder } from 'lucide-react';
import { formatUtcToLocal } from 'routes/utils';

export const FolderCard = ({
  name,
  noOfDocuments,
  lastUpdatedDate,
  onClick,
  isEmpty,
}: {
  name: string;
  noOfDocuments: number;
  lastUpdatedDate: string;
  onClick: () => void;
  isEmpty: boolean;
}) => {
  return (
    <Card
      onClick={isEmpty ? undefined : onClick}
      className={`bg-[#F6F7F9] lgl_crd border-0 ${
        isEmpty ? 'cursor-default' : 'bg-gray-50'
      }`}
      bodyStyle={{ padding: '16px' }}
    >
      <Row align='middle' gutter={16}>
        <div className='flex gap-2'>
          <Folder
            fill={isEmpty ? 'transparent' : '#B2B7C8'}
            stroke={isEmpty ? '#ddd' : 'none'}
            strokeWidth={isEmpty ? 1 : 0}
            size={62}
          />
          <div className='flex flex-col grow'>
            <div className='flex justify-between'>
              <p className='font-bold'>{name}</p>
            </div>
            {noOfDocuments > 0 ? (
              <dt className='tmrbx'>{noOfDocuments} Documents</dt>
            ) : (
              <dt className='tmrbx'>Empty Folder</dt>
            )}
            {lastUpdatedDate && (
              <dt className='tmrbx text-xs text-gray-500 mt-1'>
                Last Update{' '}
                {/* {dayjs(lastUpdatedDate).format('DD MMM YYYY | hh:mm A')} */}
                {formatUtcToLocal(dayjs(lastUpdatedDate).format('DD-MMM-YYYY'))}
              </dt>
            )}
          </div>
        </div>
      </Row>
    </Card>
  );
};
